import client from './client';

/** Праздник и его баннер на Главной (13.10.2026). Ключ = английское название из календаря Nager. */
export interface HolidayRow {
  key: string;
  name_ru: string | null;
  local_name: string | null;
  /** Ближайшие даты праздника (этот и следующий год), YYYY-MM-DD. */
  dates: string[];
  next_date: string | null;
  image_url: string | null;
  days_before: number;
  is_enabled: boolean;
  greeting_ru: string | null;
  greeting_kk: string | null;
  updated_at: string | null;
}

export interface HolidayUpdate {
  days_before?: number;
  is_enabled?: boolean;
  greeting_ru?: string;
  greeting_kk?: string;
}

const path = (key: string) => `/api/admin/holidays/${encodeURIComponent(key)}`;

export const holidaysApi = {
  list: () => client.get<{ items: HolidayRow[]; today: string }>('/api/admin/holidays'),
  update: (key: string, data: HolidayUpdate) => client.patch<HolidayRow>(path(key), data),
  uploadImage: (key: string, file: File) => {
    const fd = new FormData();
    fd.append('file', file);
    return client.post<HolidayRow>(`${path(key)}/image`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  clearImage: (key: string) => client.delete<HolidayRow>(`${path(key)}/image`),
};
